import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import ExperimentDetailPage from '~/features/experiments/pages/experiment-detail-page';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';

// `tab` + `subTab` persist the active main tab and Details sub-tab so the view
// survives reload and can be shared via copy/paste.
const searchSchema = z.object({
  tab: z.enum(['timeline', 'details', 'products']).catch('timeline'),
  // 'category' was a tab value before; it's now a viewMode dropdown option.
  // .catch('performance') gracefully handles old deep-links that still carry it.
  subTab: z.enum(['performance', 'health']).catch('performance'),
});

export type ExperimentDetailSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/_authenticated/_tenant/experiments/$id')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { tab, subTab } = Route.useSearch();
  return (
    <RequireChannelConnection>
      <ExperimentDetailPage experimentId={id} tab={tab} subTab={subTab} />
    </RequireChannelConnection>
  );
}
